// based on rc-progress 2.2.7
import Progress, { Line, Circle } from './src/';

export { Line, Circle };

export default Progress;
